// src/components/ErrorBoundary/index.tsx
import { Component, ErrorInfo, ReactNode } from 'react'
import ErrorPageComponent from '../ErrorPageComponent'

interface Props {
  children: ReactNode
  fallback?: ReactNode
}

interface State {
  hasError: boolean
  error?: Error
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    console.error('Erro capturado pelo ErrorBoundary:', error, errorInfo)
  }

  render(): ReactNode {
    if (this.state.hasError) {
      const isChunkError =
        this.state.error?.name === 'ChunkLoadError' ||
        (this.state.error?.message && this.state.error.message.includes('Loading chunk'))

      if (this.props.fallback) {
        return this.props.fallback
      }
      console.log('isChunkError', isChunkError)
      return <ErrorPageComponent refetchpage={this.handleRetry} showIcon={false} />
    }

    return this.props.children
  }

  handleRetry = (): void => {
    this.setState({ hasError: false })
    window.location.reload()
  }
}

export default ErrorBoundary
